import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import FontIcon from 'components/FontIcon';
import classes from './CardIconA.module.scss';

const CardIconA = (props) => {
  const {
    heading,
    icon,
    link,
    className,
    color = 'cool-gray',
  } = props;

  const isLink = link && link.href !== '';
  const IconContainer = isLink ? 'a' : 'div';
  const containerStyle = `border-${color}`;

  const linkAttributes = {};
  if (isLink) {
    linkAttributes.href = link.href;
    linkAttributes.target = link.target;
  }

  return (
    <div className={classNames(className, classes.container, containerStyle)}>
      <IconContainer
        {...linkAttributes}
        className={classNames(classes.iconContainer, { [classes.link]: isLink })}
      >
        {icon &&
          <FontIcon icon={icon} className={classes.icon} />}
        {heading &&
          <h4
            className={classes.heading}
            dangerouslySetInnerHTML={{ __html: heading }}
          />}
      </IconContainer>
    </div>
  );
};

CardIconA.propTypes = {
  /**
   * Heading of the card
  */
  heading: PropTypes.string,
  /**
   * Icon of the card
  */
  icon: PropTypes.string,
  /**
   * Link where you get redirected when clicking on the card
  */
  link: PropTypes.shape({
    target: PropTypes.string,
    title: PropTypes.string,
    href: PropTypes.string,
  }),
  /**
   * Custom className that wraps the card
  */
  className: PropTypes.string,
  /**
   * Border color of the card
  */
  color: PropTypes.string,
};

export default CardIconA;
